// Données du FAQ de la page Support & Aide (Formation).
// Le texte est en français (clé) ; la traduction se fait via checkMot().
//
// Les jetons `{{nom}}` sont remplacés au rendu par l’icône correspondante
// (voir faqIcons.js), pour reproduire les icônes intercalées dans le PDF
// « FAQ ARGOS ». Ils font partie de la clé de traduction : une réponse
// traduite doit donc conserver ses jetons.

export const FAQ_CATEGORIES = [
  {
    title: '1. Accès et utilisation',
    items: [
      {
        question: 'Comment modifier ses informations utilisateur ?',
        answer:
          'Si vous souhaitez modifier vos informations utilisateurs, notamment vos noms et contacts, vous devez accéder aux paramètres du profil dans le menu de gauche et cliquer sur « Profil ». Un écran s’affichera vous invitant à modifier vos informations. Cliquez sur « Ajouter un commentaire » pour revenir à la page d’accueil ou cliquer sur le logo ARGOS.',
      },
      {
        question: 'Comment personnaliser la page d’accueil ARGOS ?',
        answer:
          'Si vous souhaitez personnaliser votre page d’accueil, vous devez utiliser la fonctionnalité « Favoris » qui vous permettra d’afficher les projets, plans, graphes et tableaux de bord de votre choix.',
      },
      {
        question: 'Comment changer la langue de la plateforme ?',
        answer:
          'Pour modifier la langue paramétrée sur ARGOS, cliquez sur l’icône {{engrenage}} du menu de gauche puis sélectionnez la langue souhaitée.',
      },
      {
        question: 'Comment sélectionner des projets favoris ?',
        answer:
          'Pour sélectionner des projets favoris, cliquez sur l’icône {{favori-off}} à gauche du projet souhaité. L’icône apparaîtra jaune {{favori-on}} indiquant que le projet est considéré comme favoris. Cliquez une nouvelle fois pour retirer le projet de la catégorie « favoris ».',
      },
      {
        question: 'Comment naviguer entre plusieurs projets ?',
        answer:
          'Pour passer d’un projet à un autre, vous devez sélectionner un premier projet dans le menu de gauche puis faire défiler les projets et en sélectionner un autre.',
      },
      {
        question: 'Comment accéder à ARGOS depuis un smartphone ou une tablette ?',
        answer:
          'Pour accéder à ARGOS depuis un smartphone ou une tablette, entrez le lien url d’ARGOS dans votre barre de recherche et connectez-vous avec vos accès habituels. ARGOS est une webapp responsive et l’affichage est optimisé pour les écrans de smartphones et tablettes.',
      },
      {
        question: 'Comment utiliser le menu latéral ARGOS ?',
        answer:
          'Le menu s’affiche ou se masque en cliquant sur l’icône {{menu}}. La navigation entre les projets s’effectue en défilement vertical. Pour sélectionner un projet, vous devez cliquer sur le nom correspondant. Pour sélectionner un sous-projet, cliquez sur la flèche à gauche du nom du projet afin de déplier la section de sous-projets puis cliquez sur le nom du sous-projet souhaité.',
      },
      {
        question: 'Comment retrouver les contacts support associés à un projet ?',
        answer:
          'Vos contacts support, maintenance, data, opérationnels, sont disponible sur votre page d’accueil ARGOS, dans la partie « Contacts ». Si vous souhaitez modifier votre espace contact, adressez-vous à votre contact opérationnel qui répondra à votre besoin.',
      },
    ],
  },
  {
    title: '2. Plans',
    items: [
      {
        question: 'Comment afficher les capteurs sur un plan dynamique ?',
        answer:
          'Les capteurs s’affichent lorsque que vous cliquez sur le plan souhaité, dans la liste de l’onglet « Plans ». Sur un plan, les capteurs correspondent aux icônes colorées.',
      },
      {
        question:
          'Comment interpréter les formes et couleurs des capteurs sur les plans ?',
        answer:
          'Le code couleur correspond à l’état du capteur. L’icône présentée correspond au type de capteur. Pour afficher les données liées à un ou plusieurs capteurs, vous devez sélectionner le capteur, cela affichera une fenêtre pop-up avec les dernières données liées au capteur.',
      },
      {
        question: 'Comment rechercher un plan spécifique ?',
        answer:
          'Pour retrouver un plan spécifique, soit vous faites défiler la liste des plans dans l’onglet « Plans » jusqu’à trouver le nom de celui que vous souhaitez, soit vous effectuez une recherche de nom dans la barre de recherche en haut à gauche dans l’onglet « Plans ».',
      },
      {
        question: 'Comment ajouter un plan en favori ?',
        answer:
          'Pour ajouter un plan en favoris, vous devez cliquer une fois sur l’icône {{favori-off}} à gauche du plan souhaité. Pour retirer un plan des favoris, vous devez cliquer une nouvelle fois sur l’icône {{favori-on}}. Les plans sélectionnés en favoris apparaîtront sur votre page d’accueil.',
      },
      {
        question: 'Comment afficher un graphe depuis un plan ?',
        answer:
          'Pour ouvrir le graphe lié à un capteur, vous devez sélectionner le capteur souhaité sur le plan, cela affichera une fenêtre pop-up avec les dernières données liées au capteur. Lorsque vous cliquez sur une donnée chiffrée du capteur, cela ouvrira une fenêtre pop-up supplémentaire avec le graphe correspondant.',
      },
      {
        question: 'Comment mettre à jour l’affichage des plans en temps réel ?',
        answer:
          'Pour mettre à jour un plan affiché à l’écran, l’état des capteurs, les nouveaux capteurs ajoutés au plan, vous devez rafraîchir la page.',
      },
    ],
  },
  {
    title: '3. Graphes',
    items: [
      {
        question: 'Comment afficher un graphe ?',
        answer:
          'Pour afficher un graphe relatif à un projet, vous devez accéder à l’onglet « Graphes » et sélectionner un nom de graphe dans la liste déroulante. Une fenêtre s’affichera à droite, vous invitant à consulter les informations et les paramètres du graphe. Pour faire apparaître le graphe, cliquez sur « Afficher le graphe ». Vous avez la possibilité d’accéder à vos graphes sur votre page d’accueil en utilisant la fonctionnalité « Favoris ».',
      },
      {
        question: 'Comment rechercher un graphe existant ?',
        answer:
          'Pour retrouver un graphe spécifique, soit vous faites défiler la liste des graphes dans l’onglet « Graphes » jusqu’à trouver le nom de celui que vous souhaitez, soit vous effectuez une recherche de nom dans la barre de recherche en haut à gauche dans l’onglet « Graphes ».',
      },
      {
        question: 'Comment ajouter un graphe en favori ?',
        answer:
          'Pour ajouter un graphe en favoris, vous devez cliquer une fois sur l’icône {{favori-off}} à gauche du graphe souhaité. Pour retirer un graphe des favoris, vous devez cliquer une nouvelle fois sur l’icône {{favori-on}}. Les graphes sélectionnés en favoris apparaîtront sur votre page d’accueil.',
      },
      {
        question: 'Comment modifier les paramètres d’un graphe ?',
        answer:
          'Pour modifier les paramètres du graphe, vous pouvez soit modifier la plage de donnée et l’intervalle de temps avant de cliquer sur le bouton « Afficher le graphe », soit utiliser les outils de paramétrage lorsque le graphe est affiché à l’écran. Pour plus de détails sur les outils de paramétrages, consultez la section dédiée dans le guide d’utilisation.',
      },
      {
        question: 'Comment zoomer sur une période précise ?',
        answer:
          'Avant l’affichage du graphe, indiquez la plage horaire souhaitée dans les paramètres du graphe dans la section « paramètres de l’axe ». Lorsque le graphe est affiché, indiquez la plage horaire souhaitée en sélectionnant l’icône {{intervalle}}.',
      },
      {
        question: 'Comment exporter un graphe en image ?',
        answer:
          'Pour exporter un graphe en image .png, cliquez sur l’icône {{photo}} en haut à gauche dans la palette d’outils du graphe. Plus d’informations dans la section dédiée aux outils des graphes, dans le guide d’utilisation d’ARGOS.',
      },
      {
        question: 'Comment exporter un graphe en CSV ?',
        answer:
          'Pour exporter un graphe et ses données en CSV, cliquez sur l’icône {{csv}} en haut à gauche dans la palette d’outils du graphe. Plus d’informations dans la section dédiée aux outils des graphes, dans le guide d’utilisation d’ARGOS.',
      },
      {
        question: 'Comment comparer plusieurs capteurs sur un même graphe ?',
        answer:
          'Vous pouvez comparer plusieurs données de plusieurs capteurs sur un même graphe. Notre équipe de data manager s’occupe de paramétrer les graphes suivant vos besoins spécifiques à vos projets.',
      },
      {
        question: 'Comment interpréter les seuils affichés sur les courbes ?',
        answer:
          'Différents seuils d’alerte peuvent être paramétrés sur les graphes : des seuils bas et des seuils hauts. Les seuils correspondent à différents niveaux d’alertes : Vigilance, Alerte, Alarme, Arrêt. Pour paramétrer des seuils sur vos graphes, vous devez fournir lesdites informations relatives aux niveaux d’alertes à nos data manager.',
      },
    ],
  },
  {
    title: '4. Tableaux de bord',
    items: [
      {
        question: 'Comment afficher un tableau de bord dans ARGOS ?',
        answer:
          'Pour afficher un tableau de bord relatif à un projet, vous devez accéder à l’onglet « Tableaux de bord » et sélectionner un nom de tableau de bord dans la liste déroulante. Vous avez la possibilité d’accéder à vos tableaux de bords sur votre page d’accueil en utilisant la fonctionnalité « Favoris ».',
      },
      {
        question: 'Comment organiser les informations d’un tableau de bord ?',
        answer:
          'Les tableaux de bords des projets sont adaptés et conçus sur mesure suivant vos besoins. Notre responsable UX/UI se charge de concevoir avec vous les visualisations qui conviendront le mieux.',
      },
      {
        question: 'Comment ajouter un tableau de bord en favori ?',
        answer:
          'Pour ajouter un tableau de bord en favoris, vous devez cliquer une fois sur l’icône {{favori-off}} à gauche du tableau de bord souhaité. Pour retirer un tableau de bord des favoris, vous devez cliquer une nouvelle fois sur l’icône {{favori-on}}. Les tableaux de bord sélectionnés en favoris apparaîtront sur votre page d’accueil.',
      },
      {
        question: 'Comment rechercher un tableau de bord spécifique ?',
        answer:
          'Pour retrouver un tableau de bord spécifique, soit vous faites défiler la liste des tableaux de bord dans l’onglet « Tableaux de bord » jusqu’à trouver le nom de celui que vous souhaitez, soit vous effectuez une recherche de nom dans la barre de recherche en haut à gauche dans l’onglet « Tableau de bord ».',
      },
      {
        question: 'Comment afficher des données en temps réel ?',
        answer:
          'Suivant le paramétrage des capteurs et la réception des données, les données s’afficheront avec un délai correspondant aux spécificités et configurations du capteur. Pour avoir connaissance de ce délai, prenez contact avec votre correspondant opérationnel.',
      },
      {
        question: 'Comment mettre à jour les données affichées ?',
        answer:
          'Pour mettre à jour un tableau de bord affiché à l’écran avec ses données, vous devez rafraîchir la page.',
      },
    ],
  },
  {
    title: '5. Alarmes',
    items: [
      {
        question: 'Comment recevoir des alertes par email ou SMS ?',
        answer:
          'Afin d’optimiser l’envoi d’alertes par email ou SMS, vous devrez fournir une liste de contacts avec numéro de téléphone et adresses email. Il devra être précisé les informations d’alertes à envoyer à chaque contact.',
      },
      {
        question: 'Comment interpréter les différents niveaux d’alarme ?',
        answer:
          'Les différents niveaux d’alerte sont définis dans cet ordre (du moins au plus élevé) : Vigilance, Alerte, Alarme, Arrêt. Les différents niveaux d’alarme sont paramétrés avec les informations que vous nous aurez communiqués concernant les seuils sur vos graphes.',
      },
      {
        question: 'Comment visualiser les alarmes actives sur un projet ?',
        answer:
          'Les alarmes actives sont associées aux seuils paramétrés sur vos graphes et plus généralement sur vos projets. Les alarmes doivent être paramétrées avec notre équipe de data manager.',
      },
      {
        question: 'Comment consulter l’historique des alarmes ?',
        answer:
          'Pour afficher l’ensemble des alarmes relatives à un projet, vous devez accéder à l’onglet « Alarmes ». Les alarmes s’affichent de la dernière à la première. Vos dernières alarmes actives apparaissent également sur votre page d’accueil. La limite d’affichage des alarmes est de 5000.',
      },
      {
        question: 'Comment savoir si une alarme a été prise en compte ?',
        answer:
          'Lorsque qu’une alarme se déclenche, elle apparaît comme « visible » avec cette icône {{oeil}}. Pour indiquer qu’une alarme a été prise en compte, il faut la rendre « invisible » en cliquant sur l’icône {{oeil-barre}}.',
      },
    ],
  },
  {
    title: '6. Rapports',
    items: [
      {
        question: 'Comment télécharger un rapport PDF ?',
        answer:
          'Pour télécharger un rapport PDF, vous devez accéder à l’onglet « Rapports », sélectionner le rapport que vous souhaitez puis cliquer sur « Télécharger ».',
      },
      {
        question: 'Comment retrouver l’historique des rapports générés ?',
        answer:
          'Pour afficher l’ensemble des rapports générés pour un projet, vous devez accéder à l’onglet « Rapports ». Les rapports s’affichent du dernier au premier généré, par date. Vos derniers rapports disponibles apparaissent également sur votre page d’accueil.',
      },
    ],
  },
  {
    title: '7. Administration et droits',
    items: [
      {
        question: 'Comment sécuriser l’accès aux données ?',
        answer:
          'Pour sécuriser vos données, nous vous invitons à modifier régulièrement votre mot de passe. Pour toute information complémentaire concernant vos données, nous vous invitons à échanger avec notre équipe de data manager.',
      },
      {
        question: 'Comment gérer ses projets favoris ?',
        answer:
          'La fonctionnalité s’applique aux projets, plans, tableaux de bords et graphes. Pour ajouter un projet à la section « Favoris », il faut cliquer sur l’icône {{favori-off}} à gauche du nom du projet. Le projet sera automatiquement pris en compte comme favoris. Pour retirer un projet de la section favoris, il faut cliquer à nouveau sur l’icône {{favori-on}}. Retrouvez toutes les informations relatives à la fonctionnalité « Favoris » dans le guide d’utilisation d’ARGOS.',
      },
    ],
  },
  {
    title: '8. Maintenance et support',
    items: [
      {
        question: 'Comment contacter le support ARGOS ?',
        answer:
          'Retrouvez vos contacts support, maintenance, data, opérationnels, sur votre page d’accueil ARGOS, dans la partie « Contacts ». Ligne directe : +33(0)141064898.',
      },
      {
        question: 'Comment déclarer un incident ?',
        answer:
          'Lorsque vous détectez un incident ou une anomalie, contactez nos data manager pour trouver la meilleure solution.',
      },
      {
        question: 'Comment détecter une panne de communication ?',
        answer:
          'L’absence de communication d’un capteur est visible lorsque celui-ci apparaît en gris sur le plan. Contactez nos data manager pour avoir les informations relatives à cela.',
      },
    ],
  },
];
